import type * as Flow from '../../../shared/domain/flows/types.no-deps'
import type * as Guide from '../../../shared/domain/guides/types.no-deps'
import { Rout_create } from './Rout.create'
import { Rout_to, Rout_construct } from './Rout'
import { type LoopPathIds, toLoopPath } from '../../../shared/domain/flows/LoopPath.no-deps'

export interface Rout_GuideRoutesArgs {
    Guid_ExecutionPage: React.FunctionComponent<unknown>
}

export const Rout_GuideRoutes = (args: Rout_GuideRoutesArgs) => [
    Rout_create('/guide/execute/:guideId', args.Guid_ExecutionPage),
]

export function Rout_toGuideExecutionPage(
    guideId: Guide.Id,
    opts?: {
        procedure?: number
        unit?: number
        scrollTop?: number
        sectionId?: Flow.ElementId
        comingFromSubTask?: Flow.ReportId
        guideElementId?: Flow.ElementId
        parentClientId?: Flow.ReportId
        parentScrollTop?: string
        loopPathIds?: LoopPathIds
    }
) {
    Rout_to(Rout_toGuideExecutionPagePath(guideId, opts))
}

export function Rout_toGuideExecutionPagePath(
    guideId: Guide.Id,
    opts?: {
        procedure?: number
        unit?: number
        scrollTop?: number
        sectionId?: Flow.ElementId
        comingFromSubTask?: Flow.ReportId
        elementToRecover?: Flow.ElementId
        guideElementId?: Flow.ElementId
        parentClientId?: Flow.ReportId
        parentScrollTop?: string
        loopPathIds?: LoopPathIds
    }
) {
    return Rout_construct(`/guide/execute/${guideId}`, {
        procedure: opts?.procedure,
        unit: opts?.unit,
        scrollTop: opts?.scrollTop,
        sectionId: opts?.sectionId,
        comingFromSubTask: opts?.comingFromSubTask,
        elementToRecover: opts?.elementToRecover,
        guideElementId: opts?.guideElementId,
        parentClientId: opts?.parentClientId,
        parentScrollTop: opts?.parentScrollTop,
        loopPath: opts?.loopPathIds ? toLoopPath(opts.loopPathIds) : [],
        guideId,
    })
}
